import React, { useEffect, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import { ButtonGroup } from "react-bootstrap";
import { _get } from "../../Utils/Helper";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { ACalendar } from "../../../redux/reducers/auth";
import { acadamicTerms } from "../../../core/common/selectoption/selectoption";

interface Class {
  class_name: string;
  student_count: number;
  status: string;
}

const CollectFees: React.FC = () => {
  const routes = all_routes;
  const theme = ["btn-secondary","btn-success","btn-info"];
  const {academic_calendar} = useSelector((state :RootState)=>state.auth);

  const [classes, setClasses] = useState<Class[]>([]);

  useEffect(() => {
    _get(
      `classes?query_type=select-class-count`,
      (res) => {
        if (res && res.data) {
          setClasses(res.data);
        } else {
          console.error("Unexpected response format:", res);
        }
      },
      (err) => {
        console.error("Error fetching classes:", err);
      }
    );
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "class_name",
      render: (text: string, record: any, index: number) => <span>{text}</span>,
    },
    {
      title: "No of Students",
      dataIndex: "student_count",
      render: (text: number) => (
        <Link to="#" className="link-primary">
          {text}
        </Link>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
        render: (id: number, record: any) => (
          <ButtonGroup>
           {acadamicTerms.map((item: any, idx:number) => (
            <Link
              to={`${routes.billClasses}?class_code=${record.class_code}&term=${item.value}`}
              className={`btn ${theme[idx]}`}
            >
              {item.value}
            </Link>
           ))}
          
          </ButtonGroup>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Fees Collection</h3>
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Fees Collection</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Fees & Billings
                  </li>
                </ol>
              </nav> */}
            </div>
          </div>
          {/* /Page Header */}

          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Student Billing</h4>
              <div className="d-flex align-items-center flex-wrap">
                {/* Add filters or additional controls here if needed */}
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              <Table 
                dataSource={classes} columns={columns} 
                // selection={true} 
                />
              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
    </>
  );
};

export default CollectFees;
